import { ExportFormat, RegisteredExporter } from "../types";
import { docxExporter } from "./docxExporter";
import { htmlExporter } from "./htmlExporter";
import { xlsxExporter } from "./xlsxExporter";

/** Register exporters here. */
export const EXPORTERS: Partial<Record<ExportFormat, RegisteredExporter>> = {
  xlsx: {
    exporter: xlsxExporter,
    meta: {
      label: "Excel (.xlsx)",
      extension: "xlsx",
      mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  },
  docx: {
    exporter: docxExporter,
    meta: {
      label: "Word (.docx)",
      extension: "docx",
      mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
  },
  html: {
    exporter: htmlExporter,
    meta: {
      label: "HTML Report",
      extension: "html",
      mime: "text/html",
    },
  },
};

export function getRegisteredExportFormats(): ExportFormat[] {
  return (Object.keys(EXPORTERS) as ExportFormat[]).filter((k) => EXPORTERS[k]);
}

export function getExporter(
  format: ExportFormat
): RegisteredExporter | undefined {
  return EXPORTERS[format];
}
